export default __webpack_public_path__ + "assets/models/8643d72879bf7a83915a8037e416dceb.glb";